import { EntityActionTypeSelectOptionValue } from '../../Entity'

export const FormikEntityActionFieldInfoTooltip = {
  [EntityActionTypeSelectOptionValue.Add]:
    'Common.FormikEntityActionTypeSelectAddTooltipInfo',
  [EntityActionTypeSelectOptionValue.Edit]:
    'Common.FormikEntityActionTypeSelectEditTooltipInfo',
  [EntityActionTypeSelectOptionValue.RemoveAll]:
    'Common.FormikEntityActionTypeSelectRemoveAllTooltipInfo',
}
